module.exports = __webpack_public_path__ + "static/media/BlackPurleHaze.d8797c3c.jpg";